import { FORM } from "../mxProperties";

export const onFormSearch = async (text: string): Promise<string[]> => {
    return new Promise((resolve, _) => {
        resolve(
            FORM.map((t) => t.n.toLowerCase()).filter((t) =>
                t.toLowerCase().includes(text.toLowerCase()),
            ),
        );
    });
};
